module.exports = __webpack_public_path__ + "static/img/video-img.bb5d2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-img.jpg
// module id = IFfZ
// module chunks = 1